class ConstantsUtil {

        static accessDeniedMessage = 'Usuário sem permissão.'

        static bootstrapInputErrorClass = 'is-invalid';
        static primereactInputErrorClass = 'p-invalid';

        static campoObrigatorioLabel = 'Campo Obrigatório'
        static preecnhaLabel = 'Preencha'

        static inputNumberSmallClass = "input-number-small small-font"

        static importacaoArquivoLancamentoInventario = "LANCAMENTO_INVENTARIO"
        static importacaoArquivoProdutosDeCompra = "CADASTRO_PRODUTOS_COMPRA"

        static tooltipCadastroManualProdutoCompra = 'Só utilize esta funcionalidade caso o produto não possa ser cadastrado através de importação de Nota Fiscal de compra.'

        static virgulaEspaco = ", "
        static virgulaEspacoToRegexpSplit = /, (.*)/s

        static emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        static invalidEmailMessage = "Informe um email válido"
        static mensagemEnvioEmail = "Link para recuperação de senha enviado por email."

        static logoutPath = '/login/true/true'

        static usuarioAtivoLabel = "ATIVO"
        static systemUserId = -1

        static recoverPasswordPath = "/recoverPassword"

        static perfilSistemaLabel = 'SISTEMA'
        static perfilAdministradorLabel = 'ADMINISTRADOR'
        static perfilOperadorBancarioLabel = 'OPERADOR_BANCARIO'
        static perfilOperadorLabel = 'OPERADOR'
        static perfilOperadorCegoLabel = 'OPERADOR_CEGO'
        static perfilAlmoxarifeLabel = 'ALMOXARIFE'
        static perfilDiretorLabel = 'DIRETOR'
        static perfilOperadorPagamentoDinheiroLabel = 'OPERADOR_PAGAMENTO_DINHEIRO'
        static perfilRequisitanteEstoqueLabel = 'REQUISITANTE_ESTOQUE'
        
        static perfilSistemaLabelTratada = 'Sistema'
        static perfilAdministradorLabelTratada = 'Administrador'
        static perfilOperadorBancarioLabelTratada = 'Operador Bancário'
        static perfilOperadorLabelTratada = 'Operador'
        static perfilOperadorCegoLabelTratada = 'Operador de Caixa'
        static perfilAlmoxarifeLabelTratada = 'Almoxarife'
        static perfilDiretorLabelTratada = 'Diretor'
        static perfilOperadorPagamentoDinheiroLabelTratada = 'Operador Pagamento Dinheiro'
        static perfilRequisitanteEstoqueLabelTratada = 'Requisitante Estoque'
        
        static perfilList = 
        [
                {label: 'Selecione...', value: ''},
                {label:'Administrador', value: ConstantsUtil.perfilAdministradorLabel},
                {label:'Operador Bancário', value: ConstantsUtil.perfilOperadorBancarioLabel},
                {label:'Operador', value: ConstantsUtil.perfilOperadorLabel},
                {label:'Operador De Caixa', value: ConstantsUtil.perfilOperadorCegoLabel},
                {label:'Almoxarife', value: ConstantsUtil.perfilAlmoxarifeLabel},
                {label:'Diretor', value: ConstantsUtil.perfilDiretorLabel},
                {label:'Operador Pagamento Dinheiro', value: ConstantsUtil.perfilOperadorPagamentoDinheiroLabel},
                {label:'Requisitante Estoque', value: ConstantsUtil.perfilRequisitanteEstoqueLabel},
        ]

        static perfilErrorMessage = 'Informe o perfil.'

        static contaContabilErrorMessage = 'Informe a conta crédito'
        static historicoErrorMessage = 'Informe o histórico'

        static informeDataErrorMenssage = "Informe a data"
        static informeValorErrorMenssage = "Informe o Valor"
        static informeQuantidadeErrorMenssage = "Informe a quantidade"

        static nenhumLancamentoEncontradoMessage = 'Nenhum Lançamento Encontrado'

        static keyEnterLabel = "Enter"

        static naturezaTipoDeRecebimentoAutomaticoLabel = 'AUTOMATICO'
        static naturezaTipoDeRecebimentoBoletoLabel = 'BOLETO'
        static naturezaTipoDeRecebimentoAplicacaoFinanceiraLabel = 'APLICACAO_FINANCEIRA'
        static naturezaTipoDeRecebimentoDinheiroLabel = 'DINHEIRO'
        static naturezaTipoDeRecebimentoOutrosLabel = 'OUTROS'
        static naturezaTipoDeRecebimentoEstornoTarifaLabel = 'ESTORNO_TARIFA_BANCARIA'

        static tipoDePagamentoAplicacaoFinanceiraLabel = 'APLICAÇÃO FINANCEIRA'

        static naturezasRecebimentoNaoFechamentoCaixa = [
                ConstantsUtil.naturezaTipoDeRecebimentoAutomaticoLabel,
                ConstantsUtil.naturezaTipoDeRecebimentoAplicacaoFinanceiraLabel,
                ConstantsUtil.naturezaTipoDeRecebimentoDinheiroLabel,
                ConstantsUtil.naturezaTipoDeRecebimentoOutrosLabel,
                ConstantsUtil.naturezaTipoDeRecebimentoEstornoTarifaLabel,
                ConstantsUtil.naturezaTipoDeRecebimentoBoletoLabel,
        ]

        static avulso = 'AVULSO'
        static avulsoTipoDeRecebimentoLabel = this.avulso
        static avulsoTipoDePagamentoLabel = this.avulso
        static avulsoGrupoDePagamentoLabel = this.avulso
        static naoIdentificadoLabel = 'NÃO IDENTIFICADO'

        static nomeOutrasTarifasBancariasLabel = 'OUTRAS TARIFAS BANCÁRIAS'

        static tarifaBancaria = 'TARIFA BANCÁRIA'
        static tarifaBancariaTipoDePagamentoLabel = this.tarifaBancaria
        static tarifaBancariaGrupoDePagamentoLabel = this.tarifaBancaria

        static tipoDePagamentoNomeProperty = 'tipoDePagamento.nome'
        static tipoDeRecebimentoNomeProperty = 'tipoDeRecebimento.nomeTipoDeRecebimento'

        static escolherPeriodoLabel = 'Escolher período'

        static tiposDePagamentoNotAllowedToEdit =
        [
                this.avulsoTipoDePagamentoLabel,
                this.naoIdentificadoLabel,
                this.nomeOutrasTarifasBancariasLabel
        ]
        

        static aplicacacoesFinanceiras = 'APLICAÇÕES FINANCEIRAS'
        static aplicacacoesFinanceirasGrupoDePagamentoLabel = this.aplicacacoesFinanceiras

        static gruposDePagamentoNotAllowedToEdit =
        [
                this.avulsoGrupoDePagamentoLabel,
                this.tarifaBancariaGrupoDePagamentoLabel,
                this.aplicacacoesFinanceirasGrupoDePagamentoLabel,
                this.naoIdentificadoLabel
        ]

        static nomeTipoDeRecebimentoRendimentoAplicacaoAutomatica = 'RENDIMENTO DE APLICAÇÃO AUTOMÁTICA'

        static lancamentoBancarioRecebimentoLabel = 'RECEBIMENTO'
        static lancamentoBancarioRecebimentoAplicacaoFinanceiraLabel = 'RECEBIMENTO_REND_AP_AUTO_APLICACAO_FINANCEIRA'
        static lancamentoBancarioPagamentoLabel = 'PAGAMENTO'
        static tipoFichaBancariaLancamentoBancarioLabel = 'LANCAMENTO_BANCARIO'
        static lancamentoBancarioTransferenciaLabel = 'TRANSFERENCIA'
        static tipoFichaBancariaTransferenciaLabel = 'TRANSFERENCIA_BANCARIA'
        static lancamentoBancarioTransferenciaEntradaLabel = 'TRANSFERENCIA_ENTRADA'
        static lancamentoBancarioTransferenciaSaidaLabel = 'TRANSFERENCIA_SAIDA'
        static transferenciaRecebidaDeLabel = "Transferência Recebida de "
        static transferenciaRealizadaParaLabel = "Transferência Realizada para "
        static tipoTransacaoOFXCredit = 'CREDIT'
        static tipoTransacaoOFXDebit = 'DEBIT'

        static tipoDePagamentoAplicacaoFinanceiraInitialLabel = 'APLICAÇÃO FINANCEIRA'
        static tipoDePagamentoTarifa = 'TARIFA'
        static tipoLancamentoBancarioLabel = 'FECHAMENTO_BANCARIO'
        static tipoTotaisFichaBancariaLabel = 'TOTAIS'
        static liquidoComAcentoabel = 'LÍQUIDO'
        static tipoSaldoAnteriorFichaBancariaLabel = '"SALDO_ANTERIOR"'
        static totalSaldoAnteriorLabel = 'TOTAL SALDO ANTERIOR'
        static totalSaldoFinalLabel = 'TOTAL SALDO FINAL'
        static totaisTableLabel = 'totais'
        static totaisTableUpperCaseLabel = 'TOTAIS'
        static totalTableUpperCaseLabel = 'TOTAL'
        static mediaTableUpperCaseLabel = 'MEDIA'
        static pdvTableUpperCaseLabel = 'PDV'
        static repiqueTableUpperCaseLabel = 'REPIQUE'
        static diferencaTableUpperCaseLabel = 'DIFERENÇA'
        static pdvRelatorioFechmanetoCaixaTableClass = 'pdvRelatorioFechamentoCaixa'
        static diferencaRelatorioFechmanetoCaixaTableClass = 'diferencaRelatorioFechamentoCaixa'
        static nfManualTableClass = 'nfManual'
        

        static tipoTotaisFichaDeRecebimentoLabel = 'TOTAIS'
        static tipoUnificadoFichaDeRecebimentoLabel = 'UNIFICADO'
        static fichaDeRecebimentoSortTypeComissao = 'BY_COMISSAO'

        static resultadoNaoOperacionalLabel = 'RESULTADO'

        static resultadoOpracionalKey = 'RESULTADO_OPERACIONAL'
        static resultadoOpracionalLabel = "Resultado Operacional"

        static resultadoFinalKey = 'RESULTADO_FINAL'
        static resultadoFinalLabel = 'Resultado Final'

        static fichaBancaraiHeaderInDre = 'Lançamentos'

        static tipoDialogGrupoDePagamentoEditLabel = 'EDIT'
        static tipoDialogGrupoDePagamentoCreateLabel = 'CREATE'

        static errorTipoDeRecebimentoMessage = 'Informe o Tipo de Recebimento'

        static errorTurnoMessage = 'Informe o Turno'

        static calendarMesCompletoFilterLabel = 'mesCompleto'
        static calendarAnoCompletoFilterLabel = 'anoCompleto'
        static calendarPersonalizadoFilterLabel = 'personalizado'

        // static valueFormattedZero = 'R$ 0,00'
        static valueFormattedZero = '0,00'

        static valueFormattedLabel = 'R$'

        static destacadoNoDRECheckBoxLabel = 'Destacado no Fluxo de Caixa?'
        static ausenteNoDREPorCompetenciaCheckBoxLabel = 'Ignorar no DRE Por Competência?'
        static dreDestacadoEntrada = 'TIPO_DE_RECEBIMENTO'
        static dreDestacadoSaida = 'GRUPO_DE_PAGAMENTO'

        static tipoDePagamentoFiltroLabel = 'TIPO_DE_PAGAMENTO'
        static tipoDeRecebimentoFiltroLabel = 'TIPO_DE_RECEBIMENTO'

        static errorSelecioneEmpresasMessage = "Selecione as Empresas"

        static errorSelecioneContaBancariaMessage = "Selecione a Conta Bancária."

        static saldoInicialLabel = 'Saldo Inicial'
        static saldoFinalLabel = 'Saldo Final'
        static saldoNestaDataLabel = 'SALDO NESTA DATA'
        static saldoLabel = 'SALDO'
        static entradaLabel = 'ENTRADA'
        static saidaLabel = 'SAIDA'
        static lancamentoLabel = 'LANCAMENTO'

        static tipoFichaComparativaRecebimentoBoleto = 'RECEBIMENTO_BOLETO'
        static tipoFichaComparativaPagamentoProvisao = 'PAGAMENTO_PROVISAO'

        static parcelaProvisaoPagaLabel = "Pago"
        static parcelaProvisaoAguardandoPagamentoLabel = "Aguardando Pagamento"

        static widthColumNomeFrozenTable = '300px'
        static widthColumNomeDreConsolidado = '90px'
        static widthColumNomeSaldoDreConsolidado = '600px'
        static widthColumDreConsolidado = '50px'
        static widthColumDrePorcentagemConsolidado = '35px'
        static widthColumRelatorioFechamentoCaixa = '120px'
        static heightHeaderDREConsolidado = '15px'
        // static paddingBeetwenTablesDREConsolidado = '5px'
        static paddingBeetwenTablesDREConsolidado = '15px'

        static tipoColunaNome = "nome"
        static tipoColunaNomeFiltro = "Nome"
        static tipoColunaNomeFornecedorFiltro = "Nome Fornecedor"
        static tipoColunaMes = "mes"
        static tipoColunaPorcentagem = "porcentagem"

        static dataInicialAnteriorFinalMessage = 'Data inicial deve ser anterior à data final.'
        
        static initialTableQuantityOption = 100

        static initialRowsInNFtable = 15
        static defaultFirstInTable = 0
        static defaultSortField = ''
        static defaultSortOrder = 1

        static preferenciaColunasTelaConferenciaNFs = 'TELA_CONFERENCIA_NFS'
        
        static tipoImplantacaoSaldoSelectList = [
    
                {label: 'Selecione...', value: ''},
                {label: 'Conta Bancária', value: 'CONTA_BANCARIA'},
                {label: 'Aplicação Financeira', value: 'APLICACAO_FINANCEIRA'},
        ]
        
        
        static acrescimo = 'ACRESCIMO'
        static acrescimoLabel = 'Acréscimo'
        
        static desconto = 'DESCONTO'
        static descontoLabel = 'Desconto'
        
        static nfAcrescimoValue = this.acrescimo
        static nfDescontoValue = this.desconto

        static acrescimoDescontoSelectList = (withLabel) => {
                return [
                        {
                                label: withLabel ? 'Acréscimo/Desconto?': 'Não',
                                value: '',
                        },
                        {
                                label: 'Acréscimo',
                                value: this.nfAcrescimoValue,
                        },
                        {
                                label: 'Desconto',
                                value: this.nfDescontoValue,
                        }
                ]

        }

        static headerVersion = 'Version'
        static accessToken = 'accessToken'
        static extraHeaderObj = 'extraHeader'

        static exportXlsxLabel = "Exportar para Excel"
        static exportPdfLabel = "Exportar para PDF"


        /*
        Progress types
        */
        static importacaoFolhaDePagamentoDescricao = "FOLHA_DE_PAGAMENTO"
        static importacaoExtratoBancarioDescricao = "EXTRATO_BANCARIO"
        static importacaoLancamentosCaixa = "LANCAMENTO_CAIXA"
        static importacaoArquivosRemessaBoletos = "IMPORTACAO_ARQUIVOS_REMESSA_BOLETOS"
        static importacaoPDFNfse = "IMPORTACAO_PDF_NFSE"
        static importacaoRemessaFolhaDePagamentoDescricao = "FOLHA_DE_PAGAMENTO_CRIA_PROVISOES"

        /*
        Recursos do sistema
        */
       static fichaDePagamentoRecurso = 'FICHA_DE_PAGAMENTO'
       static lancamentoFechamentoCaixaRecurso = 'LANCAMENTO_FECHAMENTO_CAIXA'


        /*
        Estoque
        */
        static ajusteFichaDeEstoqueSobraClass = 'ajusteFichaDeEstoqueSobra' //valor em primereactTable.css
        static ajusteFichaDeEstoquePerdaClass = 'ajusteFichaDeEstoquePerda' //valor em primereactTable.css

        static selecioneOsProdutosMessage = 'Selecione os Produtos.'

        static tipoProdutoVendaLabel = 'VENDA'
        static tipoProdutoInsumoVendaLabel = 'INSUMO PARA VENDA'
        static tipoProdutoBonificacaoLabel = 'BONIFICAÇÃO'
        static tipoProdutoBonificacaoChave = 'BONIFICACAO'
        
        static tipoSyncNFsVendaTotvs = 'TOTVS'

        static cadastrarTipoDeProdutoLabel = 'Cadastrar Tipo de Produto'
        static inputTipoProduto = 'tipoProduto'
        static tipoDeProdutoLabel = 'Tipo de Produto'
        static classificacaoDRELabel = 'Classificação no DRE'
        
        static inputTipoProdutoContaGerencial = 'tipoProdutoContaGerencial'
        
        static tipoDreCompetenciaLabel = "Tipo DRE Competência"
        
        static cadastrarTipoDeEstoqueLabel = 'Cadastrar Tipo de Estoque'
        static inputTipoEstoque = 'tipoEstoque'
        static tipoDeEstoqueLabel = 'Tipo de Estoque'
        static valorCustoLabel = 'valorCusto'

        //PROVISÃO - TIPO DE RECEBIMENTO

        static origemFluxoCaixaPrevistoProvisaoRecebimento = 'Provisão de Recebimento'
        //Parametrizacao
        static situacaoParametrizacaJaParametrizado = "JA_PARAMETRIZADO"
        static situacaoParametrizacaAindaNaoParametrizado = "AINDA_NAO_PARAMETRIZADO"
        static situacaoParametrizacaONaoParametrizavel = "NAO_PARAMETRIZAVEL"

        //NFs
        static tipoNFEntradaLabel = 'ENTRADA'
        static tipoNFSaidaLabel = 'SAIDA'
        static tipoFichaDeEstoqueDevolucaoLabel = 'DEVOLUCAO'
        static tipoNFDevolucaoEntradaLabel = 'DEVOLUCAO_ENTRADA'
        static tipoNFDevolucaoSaidaLabel = 'DEVOLUCAO_SAIDA'

        static tipoDetalhamentoProdutoDeCompraLabel = 'PRODUTO_DE_COMPRA'
        static tipoDetalhamentoProdutoProprioLabel = 'PRODUTO_PROPRIO'

        static nfManualLabel = 'MANUAL'
        static nfImportacaoLabel = 'IMPORTACAO'

        static fonteNFUsuario = "USUARIO"

        static situacaoRegular = 'Documento_Regular'
        static situacaoRegularValidadaLabel = 'Validada'
        static situacaoRegularAguardandoValidacaoLabel = 'Aguardando Validação'

        static situacaoExcluida = 'Documento_Excluido'
        static situacaoExcluidaLabel = 'Excluída pelo Usuário'

        static situacaoCancelada = 'Documento_cancelado'
        static situacaoCanceladaLabel = 'Cancelada pelo Fornecedor'

        static filtroDataEmissaoLabel = 'DATA_EMISSAO'
        static filtroDataEmissaoLabelTratada = 'Data de Emissão'

        static filtroDataEntradaLabel = 'DATA_ENTRADA'
        static filtroDataEntradaLabelTratada = 'Data de Entrada'

        static empresaLabel = "Empresa"

        static codigoProdutoLabel = "Código do Produto"
        static nomeProdutoLabel = "Nome do Produto"
        static fornecedorLabel = "Fornecedor"
        static unidadeComercializadaLabel = "Unidade Comercializada"
        static numeroNFLabel = "N° Nota Fiscal"
        static situacaoNFLabel = "Situação da Nota Fiscal"
        static valorUnitarioProdutoLabel = "Valor Unitário do Produto"
        static quantidadeProdutoNaNFLabel = "Quantidade do Produto na Nota Fiscal"
        static valorTotalProdutoNaNFLabel = "Valor Total do Produto"
        static valorTotalNFLabel = "Valor Total da Nota Fiscal"
        static conversaoLabel = "Conversão"
        static qtdConvertidaEmEstoqueLabel = "Quantidade Convertida em Estoque"
        static valorProdutoUnitarioEmEstoqueLabel = "Valor do Produto Unitário de Estoque"

        static filtroDataNFOptionsList =
        [
                {
                        label: 'Selecione',
                        value: '',
                },
                {
                        label: this.filtroDataEmissaoLabelTratada,
                        value: this.filtroDataEmissaoLabel,
                },
                {
                        label: this.filtroDataEntradaLabelTratada,
                        value: this.filtroDataEntradaLabel,
                },
        ]

        static sortDirectionAsc = 'asc'
        static sortDirectionDesc = 'desc'

        static tipoNotaFiscalMercadoria = 'NF Mercadoria'
        static tipoNotaFiscalServico = 'NFSe'

        static pedidoCanceladoVmarketList = ['Cancelado pelo Fornecedor', 'Cancelado pelo Comprador']


        //DRE Competência
        static DRECompetenciaTipoEntradaLabel = 'ENTRADA'
        static DRECompetenciaTiposSaidaLabel = 'SAIDA'
        static DRECompetenciaTiposFormulaLabel = 'FORMULA'
        static DRECompetenciaGrupoReceitaBruta = "RECEITA_BRUTA"
        static DRECompetenciaGrupoDeducoesReceita = "DEDUCOES_RECEITA"
        static DRECompetenciaGrupoImpostos = "IMPOSTOS"
        static DRECompetenciaGrupoDespesasPessoal = "DESPESAS_PESSOAL"
        static DRECompetenciaGrupoDespesasPessoalLabel = "DESPESAS DE PESSOAL"
        static DRECompetenciaGrupoDespesasFuncionamento = "DESPESAS_FUNCIONAMENTO"
        static DRECompetenciaGrupoDespesasFuncionamentoLabel = "DESPESAS DE FUNCIONAMENTO"
        static DRECompetenciaGrupoOutrasDespesas = "OUTRAS_DEPESAS"
        static DRECompetenciaGrupoOutrasDespesasLabel = "OUTRAS DEPESAS"
        static DRECompetenciaGrupoReceitaFinanceira = "RECEITA_FINANCEIRA"
        static DRECompetenciaItemReceitaAplicacoesFinanceiras = "RECEITA DE APLICAÇÕES FINANCEIRAS"
        static DRECompetenciaItemReceitaDeVendas = "RECEITA DE VENDAS"
        static DRECompetenciaItemReceitaDeServicos = "RECEITA DE SERVIÇOS"
        static DRECompetenciaItemReceitaBonificacao = "RECEITA DE BONIFICAÇÃO"
        static DRECompetenciaGrupoCMV = "CMV"
        static provisoesDePagamentoHeaderLabel = "Provisões de Pagamento"
        static filtroProvisaoTipoDePagamentoId = "ID_TIPO_DE_PAGAMENTO"
        static filtroProvisaoTipoDePagamentoNome = "NOME_TIPO_DE_PAGAMENTO"
        static filtroProvisaoGrupoDePagamentoNome = "NOME_GRUPO_DE_PAGAMENTO"
        static filtroProvisaoPesquisaAvancada = "PESQUISA_AVANCADA"
        static origemProvisaoImportacaoNF = 'IMPORTACAO_NF'
        static origemProvisaoImportacaoNFLabel = 'Validação de Nota Fiscal'
        static origemProvisaoImportacaoNFSe = 'IMPORTACAO_NFSE'
        static origemProvisaoImportacaoNFSeLabel = 'Validação de NFSe'
        static origemProvisaoNFManual = 'NF_MANUAL'
        static origemProvisaoNFManualLabel = 'Lançamento Manual de Nota Fiscal'
        static origemProvisaoOutroasProvisoesManuais = 'OUTRAS_PROVISOES_MANUAIS'
        static origemProvisaoOutroasProvisoesManuaisLabel = 'Outras Provisões Manuais'
        static receitaBrutaLabel = 'RECEITA BRUTA'
        static exportListProvisaoNormal = 'PROVISAO_NORMAL'
        static exportListProvisaoProdutos = 'PROVISAO_PRODUTOS'
        static exportListProvisaoDeducoesReceita = 'PROVISAO_DEDUCOES_RECEITA'

        static getDetalhamentoOrigemLancamentoTipoProduto = (tipoProduto) => {
                return `Lançamentos de Nota Fiscal com Produtos alocados em ${tipoProduto}`
        }

        static getDetalhamentoOrigemLancamentoGrupoDeLancamento = (nomeGrupoDePagamento) => {
                return `Lançamentos de NFSe ou Provisões Manuais com Grupo de Pagamento ${nomeGrupoDePagamento}`
        }


        //Notificações
        static pagamentoParaHojeChave = 'PAGAMENTO_PARA_HOJE'
        static checkProvisoesAPagarIsFromNotificacaoSessionStorageKey = 'checkProvisoesAPagarFromNotificacao'
        


        //Geral
        static objectLabel = {
                ENTRADA: 'Entrada',
                DEVOLUCAO_ENTRADA: 'Devolução de Entrada',
                SAIDA: 'Saída',
                DEVOLUCAO_SAIDA: 'Devolução de Saída',
        }
        
        static labelsToIgnoreInFilter =
        [
                this.tipoTotaisFichaBancariaLabel,
                this.saldoNestaDataLabel,
                this.totalSaldoAnteriorLabel,
                this.totalSaldoFinalLabel
        ]

        static dataLancamentoLabel = 'Data de Lançamento'
        static dataLancamentoValue = 'DATA_LANCAMENTO'

        static dataPagamentoLabel = 'Data de Pagamento'
        static dataPagamentoValue = 'DATA_PAGAMENTO'
        
        static dataVencimentoLabel = 'Data de Vencimento'
        static dataVencimentoValue = 'DATA_VENCIMENTO'
        
        static dataCompetenciaLabel = 'Data de Competência'

        static componenteEscolherPeriodoId = 'selectedFilterType'

        static tipoFraseMotivoExclusaoNF = 'MOTIVO_EXCLUSAO_NF'
        static tipoFraseMotivoExclusaoNFSE = 'MOTIVO_EXCLUSAO_NFSE'


        static tipoFormaDePagamentoCartaoDeCredito = 'CARTAO_DE_CREDITO'
        static tipoFormaDePagamentoOutro = 'OUTRO'

        static tipoFormaDePagamentoSelectList = [
                {label: 'Selecione...', value: ''},
                {label: 'Unificação', value: this.tipoFormaDePagamentoCartaoDeCredito},
                {label: 'Outro', value: this.tipoFormaDePagamentoOutro},
        ]

        static contaGerencialGeral = 'GERAL'
        static contaGerencialEspecificaLancamento = 'ESPECIFICA_LANCAMENTO'

        static tipoContaGerencialSelectList = [
                {label: 'Geral', value: this.contaGerencialGeral},
                {label: 'Específico para este lançamento', value: this.contaGerencialEspecificaLancamento},
        ]

        static tipoDataPagamentoDiaFixoDoMes = "DIA_FIXO_DO_MES"
        static tipoDataPagamentoDiaUtilDoMes = "DIA_UTIL_DO_MES"

        static tipoDataPagamentoProvisaoRecorrente = [
                {label: 'Selecione...', value: ''},
                {label: 'Dia fixo do mês', value: this.tipoDataPagamentoDiaFixoDoMes},
                {label: 'Dia útil', value: this.tipoDataPagamentoDiaUtilDoMes},
        ]

        static getDiasDoMesList() {
                var list = [{label: 'Selecione...', value:''}]
                for (var i = 1; i <= 30; i++) {
                        list.push({label: i, value: i})
                }

                return list;
        }

        static getDiasUteisDoMesList() {
                var list = [{label: 'Selecione...', value:''}]
                for (var i = 1; i <= 22; i++) {
                        list.push({label: `${i}°`, value: i})
                }

                return list;
        }

        static tipoProcessoFolhaSelectList = [
    
            {label: 'Selecione...', value: ''},
            {label: "Geral", value: 'GERAL'},
            {label: "Folha", value: 'FOLHA'},
            {label: "Férias", value: 'FERIAS'},
            {label: "13° Salário", value: 'DECIMO_TERCEIRO'},
            {label: "Rescisão", value: 'RESCISAO'},
        ]

        static proventoFolha = "PROVENTO"
        static proventoLabel = "Provento"
        static descontoFolha = "DESCONTO"
        static descontoLabel = "Desconto"
        static liquidoFolha = "LIQUIDO"
        static liquidoLabel = "Líquido"

        static modoValorDeEstoque = 'valorDeEstoque'
        static modoReceitaDeVendas = 'receitaDeVendas'

        //Configuração
        static ARMAZENA_PDF_DANFE = "armazenaPdfDanfeNFs"
        static ARMAZENA_COMPROVANTE_PROVISAO = "armazenaComprovanteProvisao"
        static PRE_VALIDACAO_NF_ENTRADA = "possuiPreValidacaoNFsEntrada"
        static IMPEDE_CRIACAO_TIPO_PRODUTO_TIPO_ESTOQUE = "impedeCriacaoTipoProdutoTipoEstoque"
        static LABEL_REPIQUE_LANCAMENTO_FECHAMENTO_CAIXA = "labelRepiqueRelatorioFechamentoCaixa"
        static RECEITA_DE_SERVICOS = "receitaDeServicos"
        static APRESENTA_CONCILIACAO = "apresentaConciliacao"

        //IdsFixos
        static idEmpresaGrupoSistema = 1

        //pathanmes
        static historicoImportacaoNFsPathname = '/historicoImportacaoNFs'
        static syncImportacaoNFsVendaPathname = '/syncNFsVenda'
        static buscarFechamentoDeCaixaAdministradorasPathname = '/buscarFechamentoDeCaixaAdministradoras'
        static calcularPDVPathname = '/calcularPDV'
        static importarPedidosCompraPathname = '/importarPedidosCompra'
        static homePathname = '/home'
        static boletosPathname = '/boletos'
        static fichaDePagamentoPathname = '/fichaDePagamento'
        static conciliacaoBancariaPathname = '/conciliacaoBancaria'
        static fichaDeRecebimentoBoletosPathname = '/fichaDeRecebimentoBoletos'
        static lancarInventarioPathname = '/inventoryLaunch'
        static conferirLancamentoInventarioPathname = '/conferirLancamentoInventario'
        static requisicaoEstoquePathname = '/requisicaoEstoque'
        static validacaoNFsEntrada = '/validacaoNFsEntrada'
        static preValidacaoNFsEntrada = '/preValidacaoNFsEntrada'
        static validacaoNFsServico = '/validacaoNFsServico'
        static conferenciaNFServico = '/conferenciaNFServico'
        static inflacaoProdutosCompraPathName = '/inflacaoProdutosCompra'
        static folhaDePagamentoPathName = '/folhaDePagamento'
        static ddaBoletosPagamentoPathName = '/ddaBoletoPagamento'
        static lancamentoManualNFPathName = '/lancamentoManualNF'
        static lancarProvisoesRecorrentesPathName = '/lancarProvisoesRecorrentes'
        static provisionarFolhaDePagamentoPathName = '/provisionarFolhaDePagamento'
        static buscarNFePorChavePathName = '/buscarNFePorChave'
        static buscarNFSePorChavePathName = '/buscarNFSePorChave'
        static valorDeEstoquePathname = '/valorDeEstoque'
        static receitaServicoPathname = '/receitaServico'
        static lancarProvisoesAPagarPathname = '/lancamentoProvisoesAPagar'
        static lancarProvisoesAReceberPathname = '/lancamentoProvisoesAReceber'

        /*
        Componentes Digitais
        */
       static tipoComponenteDigitalComprovanteProvisaoManual = 'COMPROVANTE_PROVISAO'
       static tipoComponenteDigitalPdfNfse = 'NFSE_PDF'
       static tipoComponenteDigitalDanfeNF = 'NFS_DANFES'
       static extensaoPdf = 'pdf'

}

export default ConstantsUtil
